import { useParams } from "react-router-dom";
import { EditEnginePresetContainer } from "./container";

export const EditEnginePresetPane = () => {
  const params = useParams();
  const { id } = params;
  return id ? <EditEnginePresetContainer presetId={id} /> : <></>;
};
